import { createI18n } from 'vue-i18n';
import lang from '@/locale';

const i18n = createI18n({
  locale: lang.config.locale,
  fallbackLocale: lang.config.fallbackLocale,
  messages: lang.locales,
  datetimeFormats: lang.datetimeFormats,
  silentTranslationWarn: true,
});

export default i18n;
